import * as React from 'react';
import { FavDetailPane } from '../../components/Favorites/FavDetailUI';
import coinPrices, { CoinProps } from '../../data/coinPrices';
import { TVChartContainer } from '../../components/TVChartContainer/TVChartContainer';

type FavDetailProps = {
  currFav: number;
};

const FavEmpty = () => <FavDetailPane>No favorite selected.</FavDetailPane>;

const FavDetail: React.SFC<FavDetailProps> = ({ currFav }) => {
  if (!currFav) return <FavEmpty />;
  const coin: CoinProps = coinPrices[currFav];
  const matchSymbol = (coin: CoinProps) => {
    switch (coin.symbol) {
      case 'GO':
        return 'Kucoin:GO/BTC';
      case 'DRGN':
        return 'Kucoin:DRGN/BTC';
      case 'TFD':
        return 'Kucoin:TFD/BTC';
      case 'EOS':
        return 'Binance:EOS/BTC';
      case 'WTC':
        return 'Binance:WTC/BTC';
      case 'MFT':
        return 'Binance:MFT/BTC';
      case 'QKC':
        return 'Binance:QKC/BTC';
      default:
        return '';
    }
  };
  const symbol = matchSymbol(coin);
  return (
    <FavDetailPane>
      <div>Curr Fav: {coin.symbol}</div>
      <TVChartContainer symbol={symbol} />
    </FavDetailPane>
  );
};

export default FavDetail;



// WEBPACK FOOTER //
// ./src/containers/Favorites/FavDetail.tsx